import * as React from 'react';

export interface IStampIconProps {
  color?: string;
  size?: string | number;
  title?: string;
}

export const StampIcon = React.forwardRef<SVGSVGElement, IStampIconProps>(
  ({ color = 'currentColor', size = '1em', title = null, ...rest }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 67.000000 67.000000"
        width={size}
        height={size}
        fill={color}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <g transform="translate(0.000000,67.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
          <path
            d="M285 656 c-17 -7 -43 -28 -58 -45 -22 -26 -27 -43 -27 -84 0 -43 6
-61 36 -106 41 -61 53 -116 31 -146 -13 -16 -31 -20 -117 -25 -96 -5 -103 -7
-126 -33 -20 -23 -24 -39 -24 -93 0 -50 3 -64 15 -64 10 0 15 -10 15 -30 l0
-30 305 0 305 0 0 30 c0 20 5 30 15 30 12 0 15 14 15 64 0 54 -4 70 -24 93
-23 26 -30 28 -126 33 -86 5 -104 9 -117 25 -22 30 -10 85 31 146 30 45 36 63
36 106 0 41 -5 58 -27 84 -28 32 -78 59 -110 59 -10 -1 -32 -7 -48 -14z m122
-49 c31 -29 36 -40 36 -78 0 -35 -8 -56 -35 -97 -40 -57 -54 -114 -39 -154 14
-38 34 -45 138 -50 114 -5 133 -18 133 -90 l0 -48 -305 0 -305 0 0 48 c0 72
19 85 133 90 51 2 100 9 110 14 48 25 44 111 -8 186 -18 26 -35 58 -39 70 -11
33 11 88 45 117 44 36 90 34 136 -8z m203 -562 c0 -13 -37 -15 -275 -15 -238
0 -275 2 -275 15 0 13 37 15 275 15 238 0 275 -2 275 -15z"
          />
        </g>
      </svg>
    );
  },
);
